import React from 'react';
import { QUICK_PROMPTS } from '../../constants';
import './PromptSuggestions.css';

export function PromptSuggestions({ onSelectPrompt, disabled = false }) {
  return (
    <div className="prompt-suggestions-container">
      <span className="suggestions-header">Quick inquiries</span>
      <div className="suggestions-scroll">
        {QUICK_PROMPTS.map((prompt) => (
          <button
            key={prompt.id}
            type="button"
            className="suggestion-chip"
            onClick={() => onSelectPrompt(prompt.query)}
            disabled={disabled}
          >
            {prompt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
